"use client";

export function Footer() {
  const sections = [
    {
      title: 'Education',
      links: ['Regions', 'Grapes', 'Guides', 'Glossary']
    },
    {
      title: 'Directory',
      links: ['Wineries', 'Wines', 'Vintages', 'Search']
    },
    {
      title: 'Site',
      links: ['About', 'Contact', 'Policy', 'Contribute']
    }
  ];

  return (
    <footer style={{ backgroundColor: 'var(--paper)' }}>
      <div className="mx-auto max-w-screen-2xl px-8 lg:px-16">
        {/* Main footer content */}
        <div className="py-24 lg:py-32">
          <div className="grid gap-16 lg:grid-cols-12">
            {/* Brand - Takes more space */}
            <div className="lg:col-span-5">
              <div className="mb-8">
                <span style={{ 
                  fontFamily: 'var(--font-display)',
                  fontSize: 'var(--text-xl)',
                  fontWeight: 400,
                  color: 'var(--charcoal)',
                  letterSpacing: '-0.02em'
                }}>
                  Israeli Wine
                </span>
              </div>
              <p 
                className="max-w-md"
                style={{ 
                  fontFamily: 'var(--font-body)',
                  fontSize: 'var(--text-sm)',
                  lineHeight: 'var(--line-height-body)',
                  color: 'var(--slate)',
                  fontWeight: 300
                }}
              >
                The trusted English reference for Israeli wine—making it easy to discover, understand, and trust.
              </p>
            </div>

            {/* Links - Spread across remaining space */}
            <div className="lg:col-span-7">
              <div className="grid grid-cols-3 gap-8">
                {sections.map((section) => (
                  <div key={section.title}>
                    <h3 
                      className="mb-6"
                      style={{ 
                        fontFamily: 'var(--font-body)',
                        fontSize: 'var(--text-xs)',
                        fontWeight: 400,
                        color: 'var(--charcoal)',
                        letterSpacing: '0.1em',
                        textTransform: 'uppercase'
                      }}
                    >
                      {section.title}
                    </h3>
                    <ul className="space-y-4">
                      {section.links.map((link) => (
                        <li key={link}>
                          <a 
                            href="#"
                            className="transition-opacity duration-200 hover:opacity-50"
                            style={{ 
                              fontFamily: 'var(--font-body)',
                              fontSize: 'var(--text-sm)',
                              color: 'var(--slate)',
                              fontWeight: 300
                            }}
                          >
                            {link}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Bottom bar - minimal */}
        <div 
          className="flex flex-col gap-6 py-8 sm:flex-row sm:items-center sm:justify-between"
          style={{ borderTop: '1px solid var(--stone)' }}
        >
          <p 
            style={{ 
              fontFamily: 'var(--font-body)',
              fontSize: 'var(--text-xs)',
              color: 'var(--slate)',
              fontWeight: 300,
              letterSpacing: '0.02em'
            }}
          >
            © 2026
          </p>
          <div className="flex gap-8">
            <a 
              href="#"
              className="transition-opacity duration-200 hover:opacity-50"
              style={{ 
                fontFamily: 'var(--font-body)',
                fontSize: 'var(--text-xs)',
                color: 'var(--slate)',
                fontWeight: 300,
                letterSpacing: '0.02em'
              }}
            >
              Privacy
            </a>
            <a 
              href="#"
              className="transition-opacity duration-200 hover:opacity-50"
              style={{ 
                fontFamily: 'var(--font-body)',
                fontSize: 'var(--text-xs)',
                color: 'var(--slate)',
                fontWeight: 300,
                letterSpacing: '0.02em'
              }}
            >
              Terms
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
